<template>
  <router-view />
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import orgMonitoringModule from '@/store/org-monitoring/index'
import checkMonitoringModule from '@/store/check-monitoring'
import applyDocModule from '@/store/student'

export default {
  setup() {
    const MODULE_NAME_ORG_MONITORING = 'orgMonitoring'
    const MODULE_NAME_CHECK_MONITORING = 'checkMonitoring'
    const MODULE_NAME_APPLY_DOC = 'student'
    // Register module
    if (!store.hasModule(MODULE_NAME_ORG_MONITORING)) store.registerModule(MODULE_NAME_ORG_MONITORING, orgMonitoringModule)
    if (!store.hasModule(MODULE_NAME_CHECK_MONITORING)) store.registerModule(MODULE_NAME_CHECK_MONITORING, checkMonitoringModule)
    if (!store.hasModule(MODULE_NAME_APPLY_DOC)) store.registerModule(MODULE_NAME_APPLY_DOC, applyDocModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME_ORG_MONITORING)) store.unregisterModule(MODULE_NAME_ORG_MONITORING, orgMonitoringModule)
      if (store.hasModule(MODULE_NAME_CHECK_MONITORING)) store.unregisterModule(MODULE_NAME_CHECK_MONITORING, checkMonitoringModule)
      if (store.hasModule(MODULE_NAME_APPLY_DOC)) store.unregisterModule(MODULE_NAME_APPLY_DOC, applyDocModule)
    })
  },
}
</script>

<style scoped>

</style>
